import React from 'react';
import { StatusTip } from 'tea-component/lib';
import type { LoadingTipProps } from 'tea-component';

import './index.less';

interface LoadingProps extends LoadingTipProps {
  loading?: boolean;
  children: React.ReactNode;
}

const Loading: React.FC<LoadingProps> = (props) => {
  const { loading, children, ...restProps } = props;
  return (
    <div className="globalPedia-loading">
      {loading ? (
        <div className="globalPedia--loading-wraps">
          <StatusTip.LoadingTip {...restProps} />
        </div>
      ) : null}
      {children}
    </div>
  );
};

export default Loading;
